import { osMapPrintStore, OsMapPrintStore } from "../store";

export const updateStore = (store: Partial<OsMapPrintStore>) => {
  for (const storeKey in store) {
    const key = storeKey as keyof OsMapPrintStore;
    (osMapPrintStore[key] as unknown) = store[key];
  }
};
